import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-center-allocation-diallog-box',
  templateUrl: './center-allocation-diallog-box.component.html',
  styleUrls: ['./center-allocation-diallog-box.component.scss']
})
export class CenterAllocationDiallogBoxComponent implements OnInit {
  selectedValue: string;
  centerAllocationForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showTable = false;
  showSubmitButton = true;
  codeList: any;
  list;
  CodeSearchForm;
  APIService: any;
  isReadonly = false;
  isReadonlyDelete = false;
  deleteButton: boolean;
  dialogRef: MatDialogRef<any>;
  codeTypeList: any;
  filteredCodeType: any;
  desLabel: any;
  x = sessionStorage.getItem('CdType');
  y = sessionStorage.getItem('CdDesc');
  CdCode;
  CdType;
  CodeType: string;
  @Output() prev = new EventEmitter<void>();
  userPermission: any;
  utp: string;
  CodeCreate = true;
  CodeUpdate = true;
  CodeDelete = true;
  arr: any[] = [];
  blockData: any;
  candidate: any;
  ExamArray: FormArray;
  uploadArray: any[] = [];
  saveBtn:boolean = false
  constructor(
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private httpClient: HttpClient,
    private fb: FormBuilder,
    public router: Router,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.candidate = this.data.candidate
    this.prepopulation()
    this.CdCode = sessionStorage.getItem('CdCode');
    this.CdType = sessionStorage.getItem('CdType');
    this.x = sessionStorage.getItem('CdType');
    this.y = sessionStorage.getItem('CdDesc');
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin') {
      this.userPermission.forEach((element) => {
        if (element.PageName == 'Code' && element.PCreate == false) {
          this.CodeCreate = false;
        }
        if (element.PageName == 'Code' && element.PUpdate == false) {
          this.CodeUpdate = false;
        }
        if (element.PageName == 'Code' && element.PDelete == false) {
          this.CodeDelete = false;
        }
      });
    }
    let k = this.CdType;
    this.list = true;
    this.showTable = false;
    this.submitButton = true;
    this.editButton = false;
    this.isReadonly = false;
    this.isReadonlyDelete = false;
    this.deleteButton = false;
    this.centerAllocationForm = this.fb.group({
      ExamArray: new FormArray([], [Validators.required]),
    });
    this.CodeSearchForm = this.fb.group({
      SearchString: new FormControl(''),
    });
  }


  getExamArrayControls() {
    return (this.centerAllocationForm.get('ExamArray') as FormArray).controls;
  }

  prepopulation() {
    this.isReadonlyDelete = false;
    this.isReadonly = true;
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    const payload = {};
    payload['CgCode'] = this.data.selected.CgCode ? this.data.selected.CgCode : 0;
    this.umsService.getBlock(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.showTable = true;
          const data = res.data
          const creds = this.centerAllocationForm.controls.ExamArray as FormArray;
          creds.clear();
          data.forEach((element, i) => {

            creds.push(
              this.fb.group({
                selected: [element.Allocation ? true : false, [Validators.required]],
                BlockId: new FormControl(element.BlockId, [Validators.required]),
                CgCode: new FormControl(element.CgCode, [Validators.required]),
                CgName: new FormControl(element.CgName, [Validators.required]),
                blockName: new FormControl(element.BlockName, [Validators.required]),
                Allocation: new FormControl(element.Allocation ? element.Allocation : '', [Validators.required]),
                blockCapacity: new FormControl(element.BlockCapacity, [Validators.required])
              })
            )
          });

        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  save() {
    const examArray = this.centerAllocationForm.get('ExamArray') as FormArray;

    const selectedBlocks = examArray.controls
      // .filter(control => control.get('selected')?.value)
      .map(control => ({
        BlockName: control.get('blockName')?.value,
        Allocation: control.get('Allocation')?.value,
        BlockCapacity: control.get('blockCapacity')?.value,
        CgCode: control.get('CgCode')?.value,
        BlockId: control.get('BlockId')?.value,
        CgName: control.get('CgName')?.value
      }));
    this.umsService.updateBlock(selectedBlocks).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        } else {
          let data = {};
          data['message'] = res.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          // this.ngOnInit();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.codeList = [];
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Alert';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );

    // Now send `selectedBlocks` to your API or process as needed.
  }


  validation(index: number): void {
    const formArray = this.centerAllocationForm.get('ExamArray') as FormArray;
    const row = formArray.at(index) as FormGroup;

    const allocation = +row.get('Allocation')?.value;
    const blockCapacity = +row.get('blockCapacity')?.value;

    if (allocation > blockCapacity) {
      this.saveBtn = true
      let data = {};
      data['message'] = `Allocation cannot be greater than Block Capacity (${blockCapacity})`;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      row.get('Allocation')?.setValue(''); // or set to max allowed
    }
    else if (allocation > this.candidate) {
      this.saveBtn = true
      let data = {};
      data['message'] = `Allocation cannot be greater than Candidate Quantity (${this.candidate})`;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-check';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
      row.get('Allocation')?.setValue(''); // or set to max allowed
    }
    else{
      this.saveBtn = false
    }
    
  }
}